import SPINListView from './component';
import { TABS, LESSON_CATEGORY } from '../routes';

export default () => ({
  path: `${TABS[LESSON_CATEGORY.SPIN]}`,
  component: SPINListView,
});



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/SpinListView/routes.js